import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { Role, RolesPageState } from './typings'
import { createRole, deleteRole, getRoles } from './api'
import { loadFilterPreferences } from '@user/store/userPreferences'

const roleAdapter = createEntityAdapter<Role>()

export const initialState = roleAdapter.getInitialState<RolesPageState>({
  page: 1,
  perPage: 10,
  orderBy: 'roleName desc',
  selectedRole: undefined,
})

const roleSlice = createSlice({
  name: 'roleSlice',
  initialState,
  reducers: {
    setOrderBy: (state, { payload }: PayloadAction<string>) => {
      state.orderBy = payload
    },
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload
    },
    setPerPage: (state, { payload }: PayloadAction<number>) => {
      state.perPage = payload
    },
    setSelectedRole: (state, { payload }: PayloadAction<Role | undefined>) => {
      state.selectedRole = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRoles.fulfilled, (state, { payload }) => {
      roleAdapter.setAll(state, payload)
    })
    builder.addCase(createRole.fulfilled, (state, { payload }) => {
      roleAdapter.addOne(state, payload)
    })
    builder.addCase(deleteRole.fulfilled, (state, { payload }) => {
      roleAdapter.removeOne(state, payload)
    })
    builder.addCase(loadFilterPreferences.fulfilled, (state, { payload }) => {
      const userPref = payload.find((p) => p.type === 'roles')
      state.orderBy = userPref
        ? JSON.parse(userPref.filter).orderBy
        : 'roleName desc'
      return state
    })
  },
})

export const { setOrderBy, setPage, setPerPage, setSelectedRole } =
  roleSlice.actions

export default roleSlice.reducer

const roleSelectors = roleAdapter.getSelectors<StoreData>(
  (state) => state.roles,
)

export const { selectAll: selectAllRoles } = roleSelectors

export const selectRolesFilters = (state: StoreData) => {
  return state.roles
}
